import { Show } from "solid-js";
import { NotebookPen, Star } from "@fleet/icons";
import { cn, MOOD_EMOJIS, MOOD_VALUES, type MoodValue } from "@journal/shared";
import type { SearchResult } from "./command-palette.types";

interface ResultItemProps {
  item: SearchResult;
  index: number;
  activeIndex: number;
  globalIndex: number;
  onSelect: () => void;
  onHover: (globalIndex: number) => void;
}

export function ResultItem(props: ResultItemProps) {
  const isActive = () => props.activeIndex === props.globalIndex;
  const label = () => props.item.title?.trim() || props.item.body?.trim() || "";

  return (
    <button
      type="button"
      data-active={isActive()}
      class={cn(
        "flex items-center gap-2.5 w-full py-[9px] px-2.5 rounded-[10px] border-none bg-transparent cursor-pointer text-left transition-colors duration-80 ease-out text-foreground hover:bg-[color-mix(in_oklch,var(--accent)_70%,transparent)]",
        isActive() &&
          "bg-[color-mix(in_oklch,var(--primary)_10%,var(--accent)_60%)] active hover:bg-[color-mix(in_oklch,var(--primary)_10%,var(--accent)_60%)]",
      )}
      onClick={() => {
        props.onSelect();
      }}
      onPointerEnter={() => {
        props.onHover(props.globalIndex);
      }}
    >
      <span class="flex items-center justify-center w-7 h-7 rounded-lg shrink-0 bg-muted/80 text-muted-foreground transition-colors duration-80 ease-out">
        <Show when={props.item.is_favorite === 1} fallback={<NotebookPen class="h-4 w-4" />}>
          <Star class="h-4 w-4 fill-current text-amber-400" />
        </Show>
      </span>

      <span class="flex-1 text-[13.5px] font-[450] truncate tracking-[-0.01em]">{label()}</span>

      <Show when={MOOD_VALUES.find((value): value is MoodValue => value === props.item.mood)}>
        {(mood) => <span class="text-sm shrink-0">{MOOD_EMOJIS[mood()]}</span>}
      </Show>

      <span class="text-[10px] font-semibold tracking-[0.04em] uppercase text-muted-foreground/50 shrink-0">
        {props.item.entry_date ?? ""}
      </span>
    </button>
  );
}
